import { render, staticRenderFns } from "./DropdownOptionsBasic.vue?vue&type=template&id=80cb03c4&"
import script from "./DropdownOptionsBasic.vue?vue&type=script&lang=js&"
export * from "./DropdownOptionsBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports